import { render, staticRenderFns } from "./yuezuzhuang.vue?vue&type=template&id=1a1dbf0a&scoped=true&"
import script from "./yuezuzhuang.vue?vue&type=script&lang=js&"
export * from "./yuezuzhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1dbf0a",
  null
  
)

export default component.exports